<fgb-banner [pageTitle]="'news.page.title' | translate" />

<fgb-page-header [pageTitle]="'news.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <ng-container *ngIf="announcements$ | async as announcements; else loadingRef">
    <div class="news-list mt-lg-3" *ngIf="announcements.length > 0">
      <ng-container *ngFor="let announcement of announcements">
        <div class="news-item mb-3" *ngIf="announcements.length > 0">
          <fgbcl-announcement-content [announcement]="announcement"></fgbcl-announcement-content>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
